//React
import React from 'react';
import {
  Link
} from "react-router-dom";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
//Icon
import CloseIcon from '@material-ui/icons/Close';
import PartChargeIcon from './PartChargeIcon';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
  	}
  }


	render() {
    let contents;
    let button;
    if (this.props.checkBool === true) {
      if (this.props.checkType === 'free') {
        contents = (
          <div>
            <div  style={{margin:'10px', whiteSpace: 'pre-line'}}>
              {this.props.textareaText}
            </div>
          </div>
        )
        button = (
          <div align='center' style={{margin:'10px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'200px'}}
              onClick={ () => this.props.submit('free') }
            >
              <span style={{fontSize:'1.4em'}}>送信する</span>
            </Button>
          </div>
        )
      }
      else {
        contents = (
          <div>
            <div  style={{margin:'10px', whiteSpace: 'pre-line'}}>
              {this.props.textareaText}
            </div>
          </div>

        )
        if (this.props.checkNomatch.age) {
          button = (
            <div align='center' style={{margin:'10px'}}>
              <div style={{fontSize:'1em',color:"red"}}>お相手の希望年齢と一致していません</div>
              <Button
                variant="contained"
                color="primary"
                style={{minWidth:'200px'}}
                onClick={ () => this.props.submit('approach-pending') }
              >
                <div>
                  <div style={{fontSize:'0.9em'}}>お相手の希望年齢と一致していない方への</div>
                  <div style={{fontSize:'0.9em'}}>アプローチメールは概ね不承認になります。</div>
                  <div style={{fontSize:'1.4em'}}>それでも送信しますか？</div>
                </div>
              </Button>
            </div>
          )
        }
        else {
          button = (
            <div align='center' style={{margin:'10px'}}>
              <Button
                variant="contained"
                color="primary"
                style={{minWidth:'200px'}}
                onClick={ () => this.props.submit('approach-pending') }
              >
                <div>
                  <div style={{fontSize:'0.9em'}}>ガイドラインのチェック後に<br />12時間以内に送信されます</div>
                  <div style={{fontSize:'1.4em'}}>アプローチメールを送信する</div>
                </div>
              </Button>
            </div>
          )
        }

      }
    }
    else {
      if (this.props.checkType === 'noCharge') {
        contents = (
          <div>
            <h2 align='center'>アプローチメールはこれ以上送れません</h2>
            {
              (this.props.checkLeft > 0) && (
                <div style={{padding:'5px'}}>
                  {
                    (!this.props.my.photo.main.uriCrop) && (
                      <>
                        <Link to="/my/" style={{textDecorationLine:'underline'}}>
                          メイン写真を掲載
                        </Link>
                        いただくか、
                      </>
                    )
                  }
                  <Link to="/my/proof/" style={{textDecorationLine:'underline'}}>
                    証明書を追加
                  </Link>
                  していただくと、さらにアプローチメールが送れます。
                </div>
              )
            }
            <div style={{padding:'5px'}}>
              <span
                className='link'
                style={{textDecorationLine:'underline'}}
                onClick={ () => this.props.helpOpen('id',474) }
              >
                アプローチメールの上限について
              </span>
            </div>
            <Divider style={{margin:'10px'}} />
            <div align='center' style={{padding:'5px'}}>
              <PartChargeIcon/>
            </div>
          </div>
        )

      }
      else if (this.props.checkType === 'noProof') {
        if (this.props.my.profile.userdata_sex === 'men') {
          contents = (
            <div>
              <h2 align='center'>
                本人証明が申請されていない為<br />
                メールは送信できません
              </h2>
              <div>
                提出いただくとアプローチメールが送信できます
              </div>
            </div>
          )
        }
        else if (this.props.my.profile.userdata_sex === 'women') {
          contents = (
            <div>
              <h2 align='center'>
                本人証明が申請されていない為<br />
                メールは送信できません
              </h2>
              <div >
                本人証明を申請いただくと<br/>すべて無料でご利用いただけます。
              </div>
            </div>
          )
        }
        button = (
          <div align='center' style={{margin:'10px'}}>
            <Link to="/my/proof/person">
              <Button
                variant="contained"
                color='secondary'
                style={{minWidth:'200px'}}
              >
                <div>
                  <div style={{fontSize:'1.4em'}}>本人証明を申請する</div>
                  <div>1分ほどで簡単に申請できます</div>
                </div>
              </Button>
            </Link>
          </div>
        )
      }
      else {
        contents = (
          <div>
            <h4>メールは送れません</h4>
            {this.props.checkComment}
          </div>
        )
      }
    }

		return (
      <Dialog
        open={this.props.open}
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            メール送信
          </div>
          <IconButton
            onClick={ () => this.props.close() }
          >
            <CloseIcon/>
          </IconButton>
        </div>
        <DialogContent style={{padding:'10px'}}>
          { contents }
        </DialogContent>
        {button}
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
